'use strict';

/**
 *
 * @name: nnAllContributors
 *
 */

import DirectiveTemplate from './nn-all-contributors.directive.html';
import './nn-all-contributors.directive.scss';

function NnAllContributorsDirective() {

  return {
    replace: true,
    restrict: 'A',
    template: DirectiveTemplate,
    transclude: true,
    scope: {
      content: '&',
      loaded: '='
    },
    controller: DirectiveController
  }

  function DirectiveController ($scope, apiUserService, transObject) {

    'ngInject';

    /*
    *
    * @CONFIG
    *
    */

    $scope.settings = {
      sortOrder: {
        name: 'A_TO_Z',
        field: 'displayName asc'
      },
      sortFields: [
        {
          name: 'A_TO_Z',
          field: 'displayName asc'
        },
        // {
        //   name: 'MOST_FOLLOWED',
        //   field: 'followersCount desc'
        // },
        // {
        //   name: 'MOST_STORIES',
        //   field: 'contributionsCount desc'
        // }
      ],
      totalConts: null,
      totalContsPages: null,
      currentPage: 1
    };
    $scope.contributors = [];

    /*
    *
    * @PUBLIC
    *
    */

    $scope.loadMore = function() {

      if ( !$scope.settings.totalContsPages || $scope.settings.currentPage <= $scope.settings.totalContsPages ) {

        apiUserService
          .listUsers($scope.settings.currentPage, 15, ['contributor,brand'], $scope.settings.sortOrder.field)
          .then(res => {

            $scope.settings.totalConts = res.data.meta.totalItems;
            $scope.settings.totalContsPages = res.data.meta.totalPages;
            $scope.settings.currentPage++;

            res.data.items.forEach(function(item) {

              item.roles.push('contributor');
              transObject.trueSlug(item);
              $scope.contributors.push(item);
            });

            $scope.loaded = true;
          });
      }
    };

    /*
    *
    * @PRIVATE
    *
    */



    /*
    *
    * @INIT
    *
    */

    $scope.loadMore();

    $scope.$watch('settings.sortOrder.field', (newVal, oldVal) => {

      if (newVal === oldVal) {
        return
      }

      apiUserService
        .listUsers(1, 15, ['contributor,brand'], $scope.settings.sortOrder.field)
        .then(function(res) {

          $scope.settings.currentPage = 2;
          $scope.settings.totalConts = res.data.meta.totalItems;
          $scope.settings.totalContsPages = res.data.meta.totalPages;

          res.data.items.forEach(function(item) {

            item.roles.push('contributor');
            transObject.trueSlug(item);
          });

          $scope.contributors = res.data.items;
        });
    });
  }
}

export default NnAllContributorsDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-all-contributors/nn-all-contributors.directive.js